module.exports = __webpack_public_path__ + "img/sscx.38303473.png";